import { useNavigate } from "react-router-dom";
import { Button } from "@/components/Button/Button";

export default function RegistrationComplete() {
  const navigate = useNavigate();

  const handleReturnHome = () => {
    navigate("/"); // Navigate to your homepage
  };

  return (
    <div className="flex flex-col gap-6" data-testid="text-complete-container">
      <h1 className="text-2xl font-normal" data-testid="text-complete-heading">
        THANK YOU FOR REGISTERING WITH PAYTRIE
      </h1>

      <p className="text-base" data-testid="text-complete-message">
        Please allow up to 24 hours for us to verify your business. If we
        require more information, we will contact you by email.
      </p>

      <Button
        onClick={handleReturnHome}
        className="mt-4 inline-flex items-center py-8 px-4 w-full justify-center lg:gap-2"
        data-testid="text-complete-home-button"
      >
        RETURN TO HOMEPAGE
      </Button>
    </div>
  );
}

/*
IMPROVEMENT SUGGESTIONS:
1. Consider adding a loading state indicator during navigation
2. Add proper capitalization for button text (sentence case instead of all caps)
3. Include a more specific verification timeline or a way to check status
4. Add an email contact or help link for users who have questions during verification
5. Consider adding a confirmation number or reference ID for the registration
*/
